module.exports = { 
      attributes: {"title":"Internal tournament evaluation February 2024","categories":["shogi"],"tags":["shogi"],"language":"en","section":"shogi","slug":"internalgames202402"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = function render() { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-body"},[_c('p',[_vm._v("Our second internal handicap tournament in 2024 took place on 22.02.2024.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',[_c('data-table',{attrs:{"csvUrl":"/csv/hausliga/2024/202402.csv","hasRowNumbers":false,"columnLabels":['Place', 'Name', 'Grade', 'League modifier', 'Round', '1', '2', '3', '4', 'Points'],"boldedColumns":[0],"sortColumn":0}})],1),_vm._v(" "),_vm._m(1)]) };
            this.$options.staticRenderFns = [function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Tournament evaluation")])]) },function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Fumihiro receives +1,"),_c('br'),_vm._v("\nFlorencio receives -1,"),_c('br'),_vm._v("\nLeague modifier for the upcoming tournaments.")]) }];
          }
        }
      },
     }